// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

export const RUNNER_ACTIONS_KEY = {
  TRIGGER_SAGA_CREATE_RUNNER: 'TRIGGER_SAGA_CREATE_RUNNER',
  TRIGGER_SAGA_STOP_RUNNER: 'TRIGGER_SAGA_STOP_RUNNER',
  TRIGGER_SAGA_GET_RUNNERS: 'TRIGGER_SAGA_GET_RUNNERS',
  SET_ETL_RUNNERS: 'SET_ETL_RUNNERS',
  TRIGGER_SAGA_UPDATE_RUNNER: 'TRIGGER_SAGA_UPDATE_RUNNER',
  ADD_ETL_RUNNER: 'ADD_ETL_RUNNER',
  UPDATE_ETL_RUNNER: 'UPDATE_ETL_RUNNER',
};
